import React from 'react';

function GameWrapper({ children }) {
  return <div className='cpt-game-column'>{children}</div>;
}

export default GameWrapper;
